<template>
  <v-app class="bg-color">
    <v-main>
      <v-container fluid grid-list-xs pt-5>
        <v-layout row wrap justify-center align-center>
          <v-flex xs11 lg11>
            <h2>{{ $t("consentform.consent") }}</h2>
          </v-flex>
        </v-layout>

        <v-layout row wrap justify-center align-center pt-5>
          <v-flex xs11 lg11>
            <v-card class="rounded-lg">
              <v-card-title>
                <v-layout row wrap>
                  <v-flex xs10 lg4 ml-4>
                    <v-btn color="#077893" outlined to="/consent-create">
                      <v-icon class="mr-1">mdi-plus</v-icon>
                      {{ $t("consentform.callconsent") }}
                    </v-btn>
                    <br /><br />
                  </v-flex>
                  <v-spacer></v-spacer>
                  <v-flex xs6 lg4 mr-2>
                    <v-text-field
                      color="#077893"
                      append-icon="mdi-magnify"
                      v-model="Search"
                      outlined
                      clearable
                      :label="$t('consentlist.search')"
                      type="text"
                      dense
                    >
                    </v-text-field>
                  </v-flex>
                </v-layout>
              </v-card-title>
              <v-card-text class="mt-n5">
                <v-card outlined>
                  <v-data-table
                    class="rounded-lg"
                    calculate-widths
                    :headers="headers"
                    :items="ItemConsent"
                    :search="Search"
                    hide-default-footer
                    :page.sync="Page"
                    @page-count="PageCount = $event"
                    :items-per-page="ItemPerPage"
                  >
                    <template v-slot:[`item.ConsentId`]="{ item }">
                      <td class="text-center">
                        <div
                          class="text-center"
                          v-if="
                            item.ConsentId === '' || item.ConsentId === null
                          "
                        >
                          -
                        </div>
                        <div
                          class="text-center"
                          v-else-if="item.see_id === true"
                        >
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                v-bind="attrs"
                                color="#077893"
                                style="cursor: pointer"
                                small
                                @click="Fn_CopyDetail(item.ConsentId)"
                                v-on="on"
                                >mdi-file-multiple-outline</v-icon
                              >
                            </template>
                            <span>{{ $t("consentlist.copy") }}</span>
                          </v-tooltip>
                          {{ item.ConsentId }}
                        </div>
                        <div
                          class="text-center"
                          v-else-if="item.see_id === false"
                        >
                          ...
                        </div>
                        <center>
                          <v-btn
                            icon
                            color="#077893"
                            @click="fn_seeEmailAnalysis(item)"
                            text
                            ><v-icon>{{
                              item.see_id === true
                                ? "mdi-eye-off"
                                : "mdi-eye-settings"
                            }}</v-icon>
                          </v-btn>
                        </center>
                      </td>
                    </template>
                    <!-- <template v-slot:[`item.HeaderConsent`]="{ item }">
                    {{ item.HeaderConsent }}
                  </template> -->
                    <template v-slot:[`item.HeaderConsent`]="{ item }">
                      <div v-if="item.HeaderConsent.length < 13">
                        {{ item.HeaderConsent }}
                      </div>
                      <div v-else>
                        <v-tooltip top color="#077893" max-width="80vh">
                          <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on">{{
                              item.HeaderConsent
                            }}</span>
                          </template>
                          <span>{{ item.HeaderConsent }}</span>
                        </v-tooltip>
                      </div>
                    </template>
                    <template v-slot:[`item.UpdatdeBy`]="{ item }">
                      <div v-if="$t('default') === 'th'">
                        {{ item.UpdatdeBy }}
                      </div>
                      <div v-else>
                        {{ item.UpdatdeByEng }}
                      </div>
                    </template>
                    <template v-slot:[`item.UpdatdeAt`]="{ item }">
                      <div v-if="$t('default') === 'th'">
                        {{ item.UpdatdeAt }}
                      </div>
                      <div v-else>
                        {{ item.UpdatdeAtEng }}
                      </div>
                    </template>
                    <template v-slot:[`item.Status`]="{ item }">
                      <div
                        class="d-flex justify-center"
                        style="position: relative; left: 0.5rem"
                      >
                        <v-switch
                          @change="Fn_ChangeStatus(item, '')"
                          class="text-center"
                          color="green"
                          v-model="item.Status"
                          inset
                          dense
                        ></v-switch>
                      </div>
                    </template>
                    <template v-slot:[`item.Manage`]="{ item }">
                      <div v-if="item.Manage === 'draft'">
                        <v-chip color="orange" small dark>{{
                          $t("policy.text1")
                        }}</v-chip>
                      </div>
                      <div v-else-if="item.Manage === 'enable'">
                        <v-chip color="success" small dark>{{
                          $t("policy.text2")
                        }}</v-chip>
                      </div>
                      <div v-else>
                        <v-chip color="error" small dark>{{
                          $t("policy.text3")
                        }}</v-chip>
                      </div>
                    </template>
                    <template v-slot:[`item.TagSource`]="{ item }">
                      <div v-if="item.Manage === 'draft'"></div>
                      <div v-if="item.TagSource.length >= 1">
                        <v-icon
                          color="warning"
                          @click="Fn_UpdateConsentId(item)"
                          >mdi-pencil-outline</v-icon
                        >
                        {{ item.TagSource }}
                      </div>
                      <div v-else>
                        <v-icon
                          color="warning"
                          @click="Fn_UpdateConsentId(item)"
                          >mdi-pencil-outline</v-icon
                        >
                      </div>
                    </template>
                    <!-- <template v-slot:[`item.ReferenceVersion`]="{ item }">
                      <div v-if="item.ReferenceVersion.length >= 1">
                        <v-icon
                          color="warning"
                          @click="Fn_UpdateConsentId(item)"
                          >mdi-pencil-outline</v-icon
                        >
                        {{ item.ReferenceVersion }}
                      </div>
                      <div v-else>
                        <v-icon
                          color="warning"
                          @click="Fn_UpdateConsentId(item)"
                          >mdi-pencil-outline</v-icon
                        >
                      </div>
                    </template> -->
                    <template v-slot:[`item.Action`]="{ item }">
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            color="#077893"
                            small
                            icon
                            v-bind="attrs"
                            v-on="on"
                            @click="Fn_ViewDetail(item)"
                            dark
                          >
                            <v-icon>mdi-text-box-search</v-icon>
                          </v-btn>
                        </template>
                        <span> {{ $t("consentlist.detail") }}</span>
                      </v-tooltip>
                    </template>
                  </v-data-table>
                </v-card>

                <v-pagination
                  :total-visible="7"
                  class="pt-2 pb-2"
                  circle
                  color="#077893"
                  v-model="Page"
                  :length="PageCount"
                  prev-icon="mdi-menu-left"
                  next-icon="mdi-menu-right"
                >
                </v-pagination>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
      <div v-if="loadingDownloadData">
        <OverlaySearch />
      </div>
      <DialogConsentID
        :show="DialogConsentId"
        :data="DataConsentUpdate"
        @reset="Fn_GetDataConsent"
        @close="DialogConsentId = false"
      ></DialogConsentID>
    </v-main>
  </v-app>
</template>

<script>
import OverlaySearch from "@/components/layouts/LoadingPage.vue";
import authorization from "@/functions/authorization.js";
import Swal2 from "sweetalert2/dist/sweetalert2.js";
import { mapGetters } from "vuex";
import DialogConsentID from "../../../components/dialog/DialogConsentIdUpdate.vue";

const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export default {
  components: { DialogConsentID, OverlaySearch },
  data: function () {
    return {
      Search: "",
      Page: 1,
      Role: [],
      PageCount: 0,
      ItemPerPage: 30,
      ItemConsent: [],
      ItemDelete: [],
      DataConsentUpdate: [],
      DialogDelete: false,
      loadingDownloadData: false,
      DialogConsentId: false,
      itemsRequestTag: [],
      headers: [],
      DataSimilar: null,
    };
  },
  computed: {
    ...mapGetters(["RoleAccount"]),
    ...mapGetters(["Business"]),
    DataCheckRole: {
      get() {
        return this.$store.state.DataCheckRole;
      },
    },
  },
  created() {
    this.CopyText = this.Text;
  },
  mounted() {
    this.Fn_CheckRole();
    this.Fn_GetDataConsent();
  },
  methods: {
    async Fn_CheckRole() {
      var payload = {
        TaxId: this.$cookies.get("TaxIdCMP"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };

      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "business/GetBusinessCheckRoleApprove",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false;

          if (response.data.Status === "OK") {
            this.Role = response.data.Message.RoleApprove;
            const roleArray = Array.isArray(this.Role)
              ? this.Role
              : [this.Role];
            const roleLowerCase = roleArray.map((role) => role.toLowerCase());

            const dataCheckRoleArray = Array.isArray(this.DataCheckRole)
              ? this.DataCheckRole
              : [this.DataCheckRole];
            const dataCheckRoleLowerCase = dataCheckRoleArray.map((role) =>
              role.toLowerCase()
            );

            this.DataSimilar = roleLowerCase.some((role) =>
              dataCheckRoleLowerCase.includes(role)
            );

          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    async Fn_GetDataConsent() {
      this.loadingDownloadData = true;
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccountId: this.$cookies.get("OneAccountId"),
        RoleAccount: this.$cookies.get("RoleAccountId"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "consent/GetAllDetailConsent",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false;

          if (response.data.Status === "OK") {
            this.Fn_SetHeaderByRole();
            this.ItemConsent = response.data.Message;
            var startPage = this.Page * this.ItemPerPage - this.ItemPerPage + 1;
            var nextPage = startPage + this.ItemConsent.length;

            var number = [];
            for (var i = startPage; i < nextPage; i++) {
              number.push(i);
            }
            for (var j in this.ItemConsent) {
              this.ItemConsent[j].no = number[j];
            }
            for (var j in this.ItemConsent) {
              this.ItemConsent[j].see_id = false;
            }
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
          this.$router.push("/profile");
        });
    },
    async Fn_CopyDetail(val) {
      await navigator.clipboard.writeText(val);
    },
    Fn_UpdateConsentId(val) {
      this.DialogConsentId = true;
      this.DataConsentUpdate = val;
    },
    Fn_ViewDetail(href) {
      if (href.Manage === "draft") {
        this.$router.push({ path: "/consent-edit" });
        this.$store.dispatch("SET_DATACONSENT", href);
      } else {
        this.$router.push("/consent-detail");
        this.$store.dispatch("SET_DATACONSENT", href);
      }
    },
    async Fn_ChangeStatus(val, Reference) {
      var payload = {
        ConsentId: val.ConsentId,
        BusinessId: val.BusinessId,
        AccountId: this.$cookies.get("OneAccountId"),
        Status: val.Status,
        // ReferenceVersion: false,
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };

      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "consent/UpdateDetailConsent",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false;

          if (response.data.Status === "OK") {
            Toast.fire({
              icon: "success",
              // title: response.data.Message,
              title: this.$i18n.t("alert.upconsent"),
            });
          } else {
            val.Status = false;
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          val.Status = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
    fn_seeEmailAnalysis(item) {
      if (item.see_id === true) {
        const objIndex = this.ItemConsent.findIndex(
          (arr) => arr.no === item.no
        );
        const objdata = this.ItemConsent.find((arr) => arr.no === item.no);
        objdata.see_id = false;
        this.ItemConsent.splice(objIndex, 1, objdata);
      } else if (item.see_id === false) {
        const objIndex = this.ItemConsent.findIndex(
          (arr) => arr.no === item.no
        );
        const objdata = this.ItemConsent.find((arr) => arr.no === item.no);
        objdata.see_id = true;
        this.ItemConsent.splice(objIndex, 1, objdata);
      }
    },
    Fn_SetHeaderByRole() {
      this.headers = [];
      if (this.DataSimilar === true || this.Role.length === 0) {
        this.headers = [
          {
            text: this.$i18n.t("dashboard.num"),
            value: "no",
            sortable: false,
            align: "center",
          },
          {
            text: this.$i18n.t("consentform.consentid"),
            value: "ConsentId",
            sortable: false,
            align: "center",
          },
          {
            text: this.$i18n.t("consentform.subject"),
            align: "left",
            value: "HeaderConsent",
            sortable: false,
          },
          {
            text: this.$i18n.t("dashboard.cby"),
            value: "UpdatdeBy",
            align: "left",
            sortable: false,
          },
          {
            text: this.$i18n.t("consentform.add"),
            value: "UpdatdeAt",
            align: "left",
            sortable: false,
          },
          {
            text: this.$i18n.t("dashboard.status"),
            value: "Status",
            align: "left",
            sortable: false,
          },
          {
            text: this.$i18n.t("policy.text7"),
            value: "Manage",
            align: "left",
            sortable: false,
          },
          {
            text: "TagSource",
            value: "TagSource",
            align: "left",
            sortable: false,
          },
          {
            text: this.$i18n.t("policyForm.select"),
            value: "Action",
            align: "center",
            sortable: false,
          },
        ];
      } else {
        this.headers = [
          {
            text: this.$i18n.t("dashboard.num"),
            value: "no",
            sortable: false,
            align: "center",
          },
          {
            text: this.$i18n.t("consentform.consentid"),
            value: "ConsentId",
            sortable: false,
            align: "center",
          },
          {
            text: this.$i18n.t("consentform.subject"),
            align: "left",
            value: "HeaderConsent",
            sortable: false,
          },
          {
            text: this.$i18n.t("dashboard.cby"),
            value: "UpdatdeBy",
            align: "left",
            sortable: false,
          },
          {
            text: this.$i18n.t("consentform.add"),
            value: "UpdatdeAt",
            align: "left",
            sortable: false,
          },
          {
            text: this.$i18n.t("policy.text7"),
            value: "Manage",
            align: "left",
            sortable: false,
          },
          {
            text: "TagSource",
            value: "TagSource",
            align: "left",
            sortable: false,
          },
          {
            text: this.$i18n.t("policyForm.select"),
            value: "Action",
            align: "center",
            sortable: false,
          },
        ];
      }
    },
  },
};
</script>

<style>
td {
  border-style: hidden !important;
}

.v-data-table {
  overflow-x: auto;
}
</style>

<style scoped>
.bg-color {
  background-color: #ddf7ff;
}
</style>
